/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_ALL_TICKET_ORDERS = gql`
  query GetAllTicketOrders(
    $filters: AdminTicketOrdersFilterInput
    $options: GetManyOptions
  ) {
    getAllTicketOrders(filters: $filters, options: $options) {
      count
      skip
      limit
      content {
        ticketOrderId
        status
        releaseReason
        boxId
        boxNumber
        feteId
        feteName
        feteStartsAt
        ticketAmount
        convenienceFee
        total
        currency
        paymentMode
        paidAt
        txId
        holdExpiresAt
        createdAt
        updatedAt
        viewTicketsUrl
        masquerader {
          _id
          vuid
          firstName
          lastName
          email
          phoneNumber
        }
        lines {
          tierId
          tierName
          quantity
          unitPrice
          originalUnitPrice
          discountPct
          lineTotal
          convenienceFeePct
          feePerTicket
          lineFee
        }
        tickets {
          ticketId
          tierId
          tierName
        }
      }
    }
  }
`;

